import 'phaser'
import { common } from './common-sidecar'

export function getLayers() {
  return layers as ILayers
}

export interface ILayers {
  basic: Phaser.GameObjects.Container
  ui: Phaser.GameObjects.Container
  debug: Phaser.GameObjects.Container
}

let layers: ILayers | null = null
export function create() {
  let scene = common.getPhaserScene()

  //let main = scene.add.container(0, 0)

  layers = {
    //main,
    basic: createLayer(50),
    ui: createLayer(800, true),
    debug: createLayer(2000),
  }
  // scene.cameras.main.ignore(layers.ui)
}
export function updateAll() {}

function createLayer(depth: number, isUi: boolean = false) {
  let scene = common.getPhaserScene()

  // let cam = stevieCam.get()
  // cam.uiCamera.

  let c = scene.add.container(0, 0)
  c.depth = depth

  if (isUi) {
    c.scrollFactorX = 0
    c.scrollFactorY = 0
  }

  // parent.add(c)
  return c
}
